import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Container, Alert } from '@mui/material';
import { getStakeholderBets } from '../utils/stakeholderApi';
import StakeholderBetList from '../components/shapeup/StakeholderBetList';

/**
 * The logged-in stakeholder page: what a viewer (or any member) sees for a
 * saved view. No edit controls by construction — configuration lives only in
 * organization settings. Renders the same shared list as the public page.
 */
const StakeholderViewPage = () => {
  const { viewId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = await getStakeholderBets(viewId);
      setData(payload);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load this view.');
    } finally {
      setLoading(false);
    }
  }, [viewId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Alert severity="error" sx={{ mt: 4 }}>{error}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <StakeholderBetList view={data?.view} bets={data?.bets} />
    </Container>
  );
};

export default StakeholderViewPage;
